import { render, staticRenderFns } from "./DepositWallet.vue?vue&type=template&id=30e1a19c&scoped=true"
import script from "./DepositWallet.vue?vue&type=script&lang=js"
export * from "./DepositWallet.vue?vue&type=script&lang=js"
import style0 from "./DepositWallet.vue?vue&type=style&index=0&id=30e1a19c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e1a19c",
  null
  
)

export default component.exports